import { useContext } from 'react';
import ConfirmLogoutModalContext from './ConfirmLogoutModalContext';

const useConfirmLogoutModal = () => {
  return useContext(ConfirmLogoutModalContext);
};

export default useConfirmLogoutModal;
